import React, { useState, useEffect } from 'react';
import './ResearchGrant.css';

const ResearchGrant = () => {
  const [showForm, setShowForm] = useState(false);
  const [teamData, setTeamData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/content/team.json')
      .then(res => res.json())
      .then(data => {
        setTeamData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading team data:', error);
        setLoading(false);
      });
  }, []);

  // Get Research Grant Committee members
  const getCommitteeMembers = () => {
    if (!teamData.boardMembers && !teamData.honoraryMembers) return [];

    const allMembers = [
      ...(teamData.boardMembers || []),
      ...(teamData.honoraryMembers || [])
    ];

    const committeeNames = ['Rytis Pakrosnis', 'Ferdinand Wolf', 'Jos Kienhuis', 'Karin Phares'];
    const members = allMembers.filter(member => committeeNames.includes(member.name));

    // Sort in the specified order
    return members.sort((a, b) => {
      const indexA = committeeNames.indexOf(a.name);
      const indexB = committeeNames.indexOf(b.name);
      return indexA - indexB;
    });
  };
  return (
    <div className="research-grant-page">
      <div className="container">
        <h1 className="page-title">Research Grant</h1>
        <p className="page-subtitle">Supporting innovative research in solution-focused brief therapy across Europe and beyond</p>
        
        {/* Announcement Banner */}
        <div className="announcement-banner">
          <div className="banner-icon">🎉</div>
          <div className="banner-content">
            <h2>2025 Grant Awarded!</h2>
            <p>The EBTA Research Grant 2025 has been awarded! See the complete awards history below.</p>
          </div>
        </div>

        {/* Current Grant Info */}
        <div className="current-grant-section">
          <div className="grant-header">
            <div className="grant-icon">💰</div>
            <div>
              <h2>EBTA Research Grant 2026: Applications Open!</h2>
              <div className="grant-amount">€3,500</div>
            </div>
          </div>
          <div className="grant-details">
            <p>Are you conducting or planning research related to the Solution-Focused Approach? Do you have an innovative project that aligns with EBTA's goals?</p>
            <div className="deadline-box">
              <strong>Application Deadline: June 1, 2026</strong>
            </div>
          </div>
        </div>

        {/* Application Section */}
        <div className="application-section">
          <h2>How to Apply</h2>
          
          <div className="application-methods">
            <div className="method-card online-form">
              <div className="method-header">
                <div className="method-icon">📋</div>
                <h3>Online Application Form</h3>
              </div>
              <p>Complete the form below and it will be automatically sent to <a href="mailto:research@ebta.eu">research@ebta.eu</a></p>
              
              <button
                onClick={() => setShowForm(!showForm)}
                className={`toggle-form-btn ${showForm ? 'close' : 'open'}`}
              >
                {showForm ? '❌ Close Application Form' : '📝 Open Application Form'}
              </button>

          {showForm && (
            <div>
              <form 
                action="mailto:research@ebta.eu"
                method="post"
                encType="text/plain"
                style={{backgroundColor: 'white', padding: '2rem', borderRadius: '8px'}}
              >
            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                Title of the project *
              </label>
              <input 
                type="text" 
                name="project_title"
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                Brief description of the project *
              </label>
              <textarea 
                name="project_description"
                required
                rows="4"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem'}}>
              <div>
                <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                  Start date *
                </label>
                <input 
                  type="date" 
                  name="start_date"
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '1rem'
                  }}
                />
              </div>
              <div>
                <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                  End date *
                </label>
                <input 
                  type="date" 
                  name="end_date"
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '1rem'
                  }}
                />
              </div>
            </div>

            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                Project goals *
              </label>
              <textarea 
                name="project_goals"
                required
                rows="3"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                Methodology of the research *
              </label>
              <textarea 
                name="methodology"
                required
                rows="4"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                Specific expected results *
              </label>
              <textarea 
                name="expected_results"
                required
                rows="3"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                Work plan for project implementation *
              </label>
              <textarea 
                name="work_plan"
                required
                rows="4"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                Project expenses *
              </label>
              <textarea 
                name="project_expenses"
                required
                rows="3"
                placeholder="Please provide detailed budget breakdown"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                How the project will help to develop or spread SF-approach *
              </label>
              <textarea 
                name="sf_development"
                required
                rows="3"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                Applicant's CV *
              </label>
              <textarea 
                name="applicant_cv"
                required
                rows="5"
                placeholder="Please provide your CV details including education, experience, and relevant qualifications"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                Project team (if a project is implemented by a team)
              </label>
              <textarea 
                name="project_team"
                rows="3"
                placeholder="List team members and their roles (if applicable)"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                CV of all team members
              </label>
              <textarea 
                name="team_cvs"
                rows="4"
                placeholder="Provide CV details for all team members (if applicable)"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem'}}>
              <div>
                <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                  Applicant's Name *
                </label>
                <input 
                  type="text" 
                  name="applicant_name"
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '1rem'
                  }}
                />
              </div>
              <div>
                <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                  Country *
                </label>
                <input 
                  type="text" 
                  name="country"
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '1rem'
                  }}
                />
              </div>
            </div>

            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '2rem'}}>
              <div>
                <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                  Applicant's E-mail *
                </label>
                <input 
                  type="email" 
                  name="applicant_email"
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '1rem'
                  }}
                />
              </div>
              <div>
                <label style={{display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', color: '#374151'}}>
                  Mobile phone *
                </label>
                <input 
                  type="tel" 
                  name="mobile_phone"
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '1rem'
                  }}
                />
              </div>
            </div>

                <button 
                  type="submit"
                  style={{
                    backgroundColor: '#2563eb',
                    color: 'white',
                    padding: '1rem 2rem',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    width: '100%'
                  }}
                >
                  📧 Submit Application
                </button>
              </form>
              
              <div className="form-note">
                <p><strong>Note:</strong> The online form will open your default email client with the application details. Please ensure all fields are completed before submitting.</p>
              </div>
            </div>
          )}

            <div className="method-card pdf-download">
              <div className="method-header">
                <div className="method-icon">📄</div>
                <h3>Download PDF Forms</h3>
              </div>
              <p>Download the application form and supporting documents</p>
              
              <div className="pdf-links">
                <a 
                  href={`${process.env.PUBLIC_URL}/pdfs/2026-EBTA-Research-Grant-Application-Form.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pdf-link primary"
                >
                  📄 Application Form
                </a>
                <a 
                  href={`${process.env.PUBLIC_URL}/pdfs/EBTA-RATING-GUIDELINES_For-researchers.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pdf-link secondary"
                >
                  📊 Rating Guidelines
                </a>
                <a 
                  href={`${process.env.PUBLIC_URL}/pdfs/EBTA-Research-Grant-Accepting-Conditions-contract_2025.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pdf-link tertiary"
                >
                  📋 Grant Conditions
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* History Section */}
        <div className="history-section">
          <div className="history-header">
            <div className="history-icon">📚</div>
            <div>
              <h2>Grant Program History</h2>
              <p>Established in 2000 by Steve de Shazer</p>
            </div>
          </div>
          <div className="history-content">
            <div className="history-fact">
              <strong>Founded:</strong> August 2000 in Turku, Finland
            </div>
            <div className="history-fact">
              <strong>Total Grants Awarded:</strong> 25 grants since 2001
            </div>
            <div className="history-fact">
              <strong>Decision Body:</strong> Research Grant Committee of the EBTA Research Task Group
            </div>
          </div>
        </div>

        {/* Research Grant Committee */}
        <div className="committee-section">
          <div className="committee-header">
            <div className="committee-icon">👥</div>
            <div>
              <h2>Research Grant Committee</h2>
              <p>Members of the EBTA Research Task Group who evaluate and award grants</p>
            </div>
          </div>
          <div className="committee-content">
            <p className="committee-description">
              The Research Grant Committee is composed of members from the EBTA Research Task Group. The committee carefully evaluates all applications and selects grant recipients based on the quality, innovation, and relevance of the proposed research to the Solution-Focused approach.
            </p>
            {loading ? (
              <div style={{textAlign: 'center', padding: '2rem'}}>
                <p style={{color: '#6b7280', fontSize: '1.1rem'}}>Loading committee members...</p>
              </div>
            ) : (
              <div className="committee-members-grid">
                {getCommitteeMembers().map((member, index) => (
                  <div key={index} className="committee-member-card">
                    <div className="member-photo">
                      {member.image ? (
                        <img src={member.image} alt={member.name} />
                      ) : (
                        <div className="member-avatar-placeholder">👤</div>
                      )}
                    </div>
                    <h4 className="member-name">{member.name}</h4>
                    {member.role && <p className="member-position">{member.role}</p>}
                  </div>
                ))}
              </div>
            )}
            <p className="committee-contact">
              For questions about the grant process or the committee, please contact the Research Task Group at <a href="mailto:research@ebta.eu">research@ebta.eu</a>
            </p>
          </div>
        </div>

        {/* Awards History */}
        <div className="awards-section" id="awards-history">
          <h2>Grant Awards History</h2>
          <p className="awards-subtitle">Complete history of awarded grants from 2001 to 2025</p>
          
          <div className="table-container">
          <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem'}}>
            <thead>
              <tr style={{backgroundColor: '#f8fafc', borderBottom: '2px solid #e5e7eb'}}>
                <th style={{padding: '1rem', textAlign: 'left', fontWeight: 'bold'}}>Year</th>
                <th style={{padding: '1rem', textAlign: 'left', fontWeight: 'bold'}}>Authors</th>
                <th style={{padding: '1rem', textAlign: 'left', fontWeight: 'bold'}}>Research Project</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2025</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Neethumol Xaviour, Jaseem Koorankot, &amp; Seema P. Uthaman (Institute of Mental Health and Neurosciences, India)<br/><br/>
                  Jacqui von Cziffra-Bergs (South Africa) &amp; Anne-Marie Wulf (Denmark)
                </td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Development and Evaluation of Solution-Focused group intervention module for Adolescents with Adverse childhood experiences<br/><br/>
                  A Qualitative Study of the Applications and Interventions of Female Solution Focused practitioners in different cultures and contexts
                </td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2024</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Kim Wale (University of Stellenbosch, South Africa)</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Exploring the process of "imaginative work" in Solution-Focused Brief Therapy: Applying the Miracle Question to new mothers navigating the journey of Matrescence</td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2023</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Stefan Schmidt &amp; Johannes Fendel (University of Freiburg, Germany)</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>The Influence of a Solution Focused Individualized Open-Label-Placebo Intervention on Stress and Well-Being in Students</td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2018</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Guy Shennan &amp; Suzi Curtis (UK)<br/><br/>
                  Jaseem Koorankot &amp; Santhosh K. Rajan (India)<br/><br/>
                  Hans Pier Jara Iglesias (Peru)
                </td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Balancing preferred future talk and progress talk: a preparatory study<br/><br/>
                  Change in Neuropsychological Functions by means of Solution Focused Brief Therapy: An experimental study of clients with Depressive Disorder<br/><br/>
                  Solution-focused classrooms in educational institutions of the city of Trujillo: outcomes of solution-focused schoolwork in contexts of psychosocial risk
                </td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2017</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Jaroslaw Lelonkiewicz &amp; Alessia Tosi (Poland)</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Lexical convergence and therapeutic alliance in Solution-focused Brief Therapy sessions</td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2016</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Jaseem Koorankot, Z. A. Ashraf, &amp; K. R. Santhosh (India)</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Effects of solution focused vs. problem focused questions in neuropsychological components and electrophysiological state</td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2015</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Christiaan Van Woerden et al. (University of Cape Town, South Africa)<br/><br/>
                  Miriam Lommen (University of Oxford, UK) &amp; Simon Dymond (University of Swansea, Wales)
                </td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Qualitative analysis of Solution Focused Practice in History Taking by pediatric clerks and registrars<br/><br/>
                  A pilot study of brief therapy for reducing overgeneralization of fear through solution-focused discrimination training
                </td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2013</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Rytis Pakrosnis &amp; Viktorija Cepukiene (Vytautas Magnus University, Lithuania)</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Effectiveness of a solution-focused, computer-assisted self-help tool</td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2012</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Antonio Medina (Tenerife, Spain)</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Solution-Focused child protection work with children at risk and their families in local public agencies in Tenerife, Spain. A quasi-experimental outcome study</td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2011</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Keita Kiuchi et al. (Japan)<br/><br/>
                  George Abramson (UK)
                </td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Seeking to develop a general solution-focused attitude scale (GSFAS) that will serve as an effective indicator to measure the effectiveness of SFBT<br/><br/>
                  A microanalysis of Signs of Safety child protection conversations in social work
                </td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2010</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Ivana Vidakovic &amp; Stephen M. Langer (Croatia)<br/><br/>
                  Lehmann P. &amp; Moore B. (USA)
                </td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  SFT treatment for PTSD; 20 experimental and 20 controls planned. Detailed one-year follow-up using objective measures and fidelity testing<br/><br/>
                  Pre-post design for 100 men convicted of domestic violence who attend a group programme
                </td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2008-2009</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Marieta Igarenska, Kiril Elenski &amp; Gergana Foreva (Bulgaria)<br/><br/>
                  Janet Bavelas, Sara Healing &amp; Christine Tomori (Canada)
                </td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Investigating the effect of SFBT in cardiovascular disease patients<br/><br/>
                  Microanalysis of Miracle Question
                </td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2007</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Plamen Panayotov (Bulgaria)</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Medication compliance in schizophrenia improved by SFT</td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2005</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  Lisbeth Kvarme (University of Bergen, Norway)<br/><br/>
                  Steve Myers (UK)
                </td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>
                  An intervention study in the school health service to find out if solution-focused therapy contributes to strengthen self-efficacy and quality of life of pupils who have been exposed to bullying<br/><br/>
                  Study of treatment for juvenile sexual offenders
                </td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2004</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Frederic Linssen (Germany)</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>A study of a large number of SFTP-clients using pre-test, post-test, and one year follow-up, including measures of satisfaction with therapy. Design similar to EBTA protocol; using different measures</td>
              </tr>
              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2002</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Elka Bozhkova (Bulgaria)</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Include EBTA multi-centre research design within a larger study of SFT on a cohort of clients in a psychiatric rehabilitation service. Project showed greater benefit from SFT with or without medication than medication alone or medication plus psycho-educational group therapy</td>
              </tr>
              <tr>
                <td style={{padding: '1rem', verticalAlign: 'top', fontWeight: 'bold'}}>2001</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>Karin Wallgren Thorslund (Sweden)</td>
                <td style={{padding: '1rem', verticalAlign: 'top'}}>A randomized controlled trial of group SFT for chronic sick persons in Sweden in order to return them to work</td>
              </tr>
            </tbody>
          </table>
        </div>
        
          </div>
          
          <div className="table-note">
            <p>* No Research Grants awarded in 2003, 2006, 2014, 2019-2022.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResearchGrant;
